import { padSecret } from '@Constants/TableColumns';
import { buildPositionElementId } from '@Hooks/Navigation';
import { type ApiExternalApplicationSecret } from '@Model';
import {
    DateInput,
    DivWithSpacing,
    Grid,
    GridColumns,
    ISubFrameBodyProps,
    TextInput,
    TextInputBase,
    useGuiBinder,
    useProp,
} from '@synqo/frontend-component-library';
import { useMemo } from 'react';
import { monthsAfter, secretExpiryPresets } from './secretExpiry';

export function FrameEditExternalApplicationSecret(props: ISubFrameBodyProps<ApiExternalApplicationSecret>) {
    const secret = props.data;
    const binder = useGuiBinder<ApiExternalApplicationSecret>(props);
    const labelField = useProp(binder, 'label');
    const expiresAtField = useProp(binder, 'expires_at');

    const value = secret.value;

    const paddedSecret = useMemo(() => padSecret(value), [value]);
    const today = new Date();
    const earliestExpiry = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 7);
    const latestExpiry = monthsAfter(today, 24);

    if (!secret.is_activated) {
        return (
            <DivWithSpacing
                id={buildPositionElementId(secret.id)}
                padding={{ left: 'lg', right: 'lg', top: 'md', bottom: 'md' }}
                className={'w-full'}
            >
                <Grid columns={12}>
                    <GridColumns spans={[4, 4, 4]}>
                        <TextInput {...labelField} label="Bezeichnung" required readOnly={secret.is_activated} />
                        <DateInput
                            type="day"
                            {...expiresAtField}
                            label="Gültig bis"
                            required
                            presets={secretExpiryPresets}
                            minDate={earliestExpiry}
                            maxDate={latestExpiry}
                        />
                        <TextInputBase
                            name="value"
                            key="value"
                            value={''}
                            label="Wert"
                            placeholder="Wird beim Speichern vergeben"
                            locked
                            onChange={() => false}
                        />
                    </GridColumns>
                </Grid>
            </DivWithSpacing>
        );
    }

    return (
        <DivWithSpacing
            id={buildPositionElementId(secret.id)}
            padding={{ left: 'lg', right: 'lg', top: 'md', bottom: 'md' }}
            className={'w-full'}
        >
            <Grid columns={12}>
                <GridColumns spans={[3, 3, 6]}>
                    <TextInput {...labelField} label="Bezeichnung" required readOnly={secret.is_activated} />
                    <DateInput type="day" {...expiresAtField} label="Gültig bis" locked />
                    <TextInputBase
                        name="value"
                        key="value"
                        value={paddedSecret}
                        label="Wert"
                        locked
                        onChange={() => false}
                    />
                </GridColumns>
            </Grid>
        </DivWithSpacing>
    );
}
